import {ProFormDateTimePicker} from "@ant-design/pro-components";
import {Form, message} from 'antd';
import React from 'react';
import request from "umi-request";
import apiConfig from '../config/api'
import {getHeaders} from "./request";

export const timeFormat = {
    format: "YYYY-MM-DD HH:mm:00"
}

export const isRcsProject = () => {
    return false
}

export const getToday = () => {
    let date = new Date();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return date.getFullYear() + "-" + ( month < 10 ? '0' + month : month) + "-" + (day < 10 ? '0' + day : day);
}

export const getTodayArr = () => {
    let today = getToday();
    return [today, today]
}

export const formatNumber = (num) => {
    if(!num || num < 1000){
       return num;
    }
    return (num + "").replace(/\B(?=(?:\d{3})+\b)/g, ',')
}

export const calcPhoneCount = (files) => {
    let sum = 0;
    for(let i = 0; i < files.length; i++){
        let file = files[i];
        sum += file.total;
    }
    return sum;
}

export const waitSecond = (millSecond) => {
    return new Promise((resolve, reject)=>{
        setTimeout(()=>{
            resolve(true);
        }, millSecond)
    })
}

export const formatFullTable = (data) => {
    if (!data) {
        message.warning('加载失败').then();
        return { success: false };
    }
    return {
        total: (data || []).length,
        data: data || [],
        success: true,
    };
};

export const formatPageTable = (result) => {
    return {
        success : !!result,
        data : result?.list,
        total : result?.total
    };
};

export const requiredRule = [{ required: true }];

export const parseTableSort = (sort = {}, tablePrefix) => {
    let arr = [];
    for(let key in sort){
        key = key.replace(/[A-Z]/, (v) => {
            return "_" + v.toLowerCase()
        })
        arr.push((tablePrefix ? tablePrefix + "." : "") + key + " " + (sort[key] === "ascend" ? "ASC" : "DESC"))
    }
    return arr.join(",");
}

export const extractRegionNames = (list) => {
    let names = [];
    for (let provinceId in list) {
        const province = list[provinceId];
        const directCity = ['北京', '上海', '重庆', '天津'].includes(province.title.replace('市', ''));
        const allLabel = directCity ? '全市' : '全省';
        let provinceName = list[provinceId].title;
        if (province.checkAll) {
            provinceName += '(' + allLabel + ')';
        } else {
            provinceName += '(';
            if (province.list) {
                for (let cityId in province.list) {
                    const city = province.list[cityId];
                    provinceName += city.title + '、';
                }
            }
            provinceName += ')';
            provinceName = provinceName.replace('、)', ')');
        }
        names.push(provinceName);
    }
    return names.join('、');
};

export const fromObject = (obj) => {
  return obj ? JSON.parse(JSON.stringify(obj)) : obj
}

export const commonDateRange = ({label = "活动", startName = "startTime", endName = "endTime", hasStart = false}) => {
    return (
        <Form.Item label={label + "时间"} className="inline-group" required={true}>
            <ProFormDateTimePicker disabled={hasStart} name={startName} rules={requiredRule} fieldProps={timeFormat} placeholder={label + "开始时间"} />
            <span className="space">至</span>
            <ProFormDateTimePicker name={endName} rules={requiredRule} fieldProps={timeFormat} placeholder={label + "结束时间"} />
        </Form.Item>
    )
}

export const getNestedValue = (data, key = []) => {
    if(!Array.isArray(key)){
        return data[key];
    }
    let value = data;
    key.forEach(item=>{
        value = value[item]
    })
    return value;
}

export const mergeArrById = (arr1, arr2) => {
    return [...arr1, ...arr2.filter(r=>!arr1.some(b=>b.id === r.id))]
}

export const exportHelper = async (promiseFunc) => {
    message.loading("正在导出，请稍后", 0);
    try {
        let result = await promiseFunc;
        message.destroy();
        if (result?.url) {
            let link = document.getElementById("fileLink");
            if(!link){
               link = document.createElement("a");
               link.style.display = "none";
               document.body.appendChild(link);
            }
            link.href = result.url.indexOf("http") === 0 ? result.url : apiConfig.baseUrl + result.url;
            link.click();
        }else{
            message.warning("没有数据或其它问题，请稍后重试");
        }
    }catch (e){
        message.warning("导出失败，请稍后重试", 2);
    }finally {
        setTimeout(()=>{
            message.destroy();
        }, 2000)
    }
}

export const exportFile = (file) => {
    let link = document.getElementById("fileLink");
    if(!link){
        link = document.createElement("a");
        link.style.display = "none";
        document.body.appendChild(link);
    }
    link.target = "_blank";
    link.href = file.indexOf("http") === 0 ? encodeURI(file) : apiConfig.baseUrl + encodeURI(file);
    console.log(link.href)
    link.click();
}

export const downloadFile = (url) => {
    request(apiConfig.baseUrl + url, {
        method: 'POST',
        headers: getHeaders(),
        responseType: 'blob',
    }).then(res => {
        const blob = new Blob([res]);
        const objectURL = URL.createObjectURL(blob);
        let btn = document.createElement('a');
        btn.style.display = "none";
        //btn.download = '文件.docx';
        btn.href = objectURL;
        btn.click();
        URL.revokeObjectURL(objectURL);
        btn = null;
    });
}

export const objToArr = (obj) => {
    if(!obj){
       return [];
    }
    let result = []
    for(let key in obj){
        result.push({name: key, value: obj[key]})
    }
    return result;
}
